<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import Breadcrumbs from "../Breadcrumbs.vue";
import NotificacionesBell from "@/components/NotificacionesBell.vue";
import { useAuth } from "@/composables/useAuth";

const { user } = useAuth();


const store = useStore();
const isRTL = computed(() => store.state.isRTL);

const route = useRoute();

const currentRouteName = computed(() => {
  return route.name;
});
const currentDirectory = computed(() => {
  let dir = route.path.split("/")[1];
  return dir.charAt(0).toUpperCase() + dir.slice(1);
});

// Debajo de 1200px (breakpoint "xl") el botón abre/cierra el drawer del
// sidenav; en escritorio conserva el comportamiento original de minimizar
// a solo íconos.
const minimizeSidebar = () => {
  if (window.innerWidth < 1200) {
    store.commit("toggleMobileSidenav");
  } else {
    store.commit("sidebarMinimize");
  }
};


</script>
<template>
  <nav class="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl"
    :class="isRTL ? 'top-0 position-sticky z-index-sticky' : ''" v-bind="$attrs" id="navbarBlur" data-scroll="true">
    <div class="px-3 py-1 container-fluid">
      <breadcrumbs :current-page="currentRouteName" :current-directory="currentDirectory" />

      <div class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4" :class="isRTL ? 'px-0' : 'me-sm-4'"
        id="navbar">
        <!-- La barra de búsqueda nunca colapsaba en mobile (igual que el resto
             de este navbar, ver comentario en minimizeSidebar): en celulares
             angostos competía por espacio con la campana y la hamburguesa y
             rompía el layout (el input quedaba tan angosto que el bell
             terminaba anclado en una posición rota). Se oculta por debajo de
             576px, donde su ancho mínimo útil no entra igual; en tablet/
             escritorio queda exactamente igual que antes. -->
        <div class="pe-md-3 d-none d-sm-flex align-items-center" :class="isRTL ? 'me-md-auto' : 'ms-md-auto'">
          <div class="input-group">
            <span class="input-group-text text-body">
              <i class="fas fa-search" aria-hidden="true"></i>
            </span>
            <input type="text" class="form-control" :placeholder="isRTL ? 'أكتب هنا...' : 'Type here...'" />
          </div>
        </div>
        <ul class="navbar-nav justify-content-end">

          <notificaciones-bell v-if="user" />

          <li class="nav-item ps-3 d-flex align-items-center">
            <a href="#" @click.prevent="minimizeSidebar" class="p-0 nav-link text-white" id="iconNavbarSidenav">
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line bg-white"></i>
                <i class="sidenav-toggler-line bg-white"></i>
                <i class="sidenav-toggler-line bg-white"></i>
              </div>
            </a>
          </li>


        </ul>
      </div>
    </div>
  </nav>
</template>
